import { Component, OnInit } from "@angular/core";
import { ClassificationRequest, ClassificationRequestItem } from "../../objects/zonos/classificationRequest";
import { LandedCostRequest } from "../../objects/zonos/landedCostRequest";
import { ZonosService } from "../../services/zonos.service";
import { DutyTaxRequest } from "../../objects/zonos/dutyTaxRequest";

@Component({
    selector: 'classification',
    templateUrl: 'zonos.component.html',
    moduleId: module.id.toString()
})
export class ZonosComponent implements OnInit {
    public classificationRequest: ClassificationRequest;
    public dutyTaxRequest: DutyTaxRequest;
    public classificationResponseStr: string = "";
    public landedCostRequest: LandedCostRequest;
    public landedCostResponseStr: string = "";

    constructor(private zonosService: ZonosService) {
    }

    public ngOnInit(): void {
        this.classificationRequest = new ClassificationRequest();
        this.classificationRequest.item = new ClassificationRequestItem();
        this.dutyTaxRequest = new DutyTaxRequest();
        this.landedCostRequest = new LandedCostRequest();
    }

    public SendClassificationRequest(valid: boolean): void {
        if(!valid)
            return;
        this.dutyTaxRequest.ship_to.country = this.classificationRequest.ship_to_country;
        this.dutyTaxRequest.items[0].id = this.classificationRequest.item.id;
        this.dutyTaxRequest.items[0].brand = this.classificationRequest.item.brand;
        this.dutyTaxRequest.items[0].category = this.classificationRequest.item.category;
        this.dutyTaxRequest.items[0].description_retail = this.classificationRequest.item.description;
        this.dutyTaxRequest.items[0].detail = this.classificationRequest.item.detail;
        this.dutyTaxRequest.items[0].hs_code = this.classificationRequest.item.hs_code;
        this.dutyTaxRequest.items[0].image_url = this.classificationRequest.item.image_url;
        this.dutyTaxRequest.items[0].upc_code = this.classificationRequest.item.upc_code;

        this.zonosService.classification({ ClassificationRequest: this.classificationRequest, DutyTaxRequest: this.dutyTaxRequest }).then(data => {
            this.classificationResponseStr = JSON.stringify(data.Data);
        });
    }

    public SendLandedCostRequest(valid: boolean): void {
        if(!valid)
            return;
        this.zonosService.landedCost(this.landedCostRequest).then(data => {
            this.landedCostResponseStr = JSON.stringify(data.Data);
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/zonos/zonos.component.ts